module.exports = __webpack_public_path__ + "static/media/hegic.97045147.svg";